import { useCallback } from 'react';

function useAriaLabel(data, options = {
  xAxisLabelFormatter: undefined,
  yAxisLabelFormatter: undefined
}) {
  return useCallback(function getAriaLabel({
    seriesIndex,
    key
  }) {
    const {
      xAxisLabelFormatter,
      yAxisLabelFormatter
    } = options;
    const ariaSeries = data.map(({
      name,
      data
    }) => data[seriesIndex] ? `${name} ${xAxisLabelFormatter ? xAxisLabelFormatter(data[seriesIndex].value) : data[seriesIndex].value}` : '').join(', ');
    return key ? `${yAxisLabelFormatter ? yAxisLabelFormatter(key) : key}: ${ariaSeries}` : '';
  }, [data, options]);
}

export { useAriaLabel };
